const leftAlignedCell = 'left-align-header-v2';
const rightAlignedCell = 'right-align-header-v2';
const brokerageRightAlignedCell = 'right-align-header-brokerage-v2';

// ytd table headers
export const ytdTableHeaders = [
    {
        id: 'ytd-accounts-header-v2',
        className: leftAlignedCell,
        title: 'Accounts',
        variant: 'group'
    },
    {
        id: 'ytd-income-dividends-header-v2',
        className: rightAlignedCell,
        title: 'Income Dividends',
        variant: 'group'
    },
    {
        id: 'ytd-long-term-cap-header-v2',
        className: rightAlignedCell,
        title: 'Long-Term Capital Gains',
        variant: 'group'
    },
    {
        id: 'ytd-short-term-cap-header-v2',
        className: rightAlignedCell,
        title: 'Short-Term Capital Gains',
        variant: 'group'
    },
    {
        id: 'ytd-foreign-withholdings-header-v2',
        className: rightAlignedCell,
        title: 'Foreign Withholdings',
        variant: 'group'
    },
    {
        id: 'ytd-federal-income-tax-withholdings-header-v2',
        className: rightAlignedCell,
        title: 'Federal Income Tax Withholdings',
        variant: 'group'
    },
    {
        id: 'ytd-foreign-taxes-paid-header-v2',
        className: rightAlignedCell,
        title: 'Foreign Taxes Paid',
        variant: 'group'
    }
];

export const ytdTableColumns = [
    'IncomeDividends',
    'LongTermCapitalGains',
    'ShortTermCapitalGains',
    'ForeignWithholding',
    'FederalWithholding',
    'ForeignTaxesPaid'
];

// cost basis table headers
export const UNREALIZED = 'Unrealized';
export const REALIZED = 'Realized';

export const costBasisTableOptions = [
    {
        label: UNREALIZED,
        value: UNREALIZED
    },
    {
        label: REALIZED,
        value: REALIZED
    }
];

export const unrealizedTableColumns = [
    'shares',
    'costPerShare',
    'costBasisAmount',
    'marketValue',
    'gainLossAmount',
    'gainLossPercent'
];

export const unrealizedTableHeaders = (hasBrokerageRASOrAdvisoryFund = false) => {
    const headers = [
        {
            id: 'cds-accounts-header-v2',
            className: `${hasBrokerageRASOrAdvisoryFund ? "accounts-brokerage-header" : leftAlignedCell} cds-account-header-v2`,
            title: 'Accounts',
            variant: 'group'
        },
        {
            id: 'cds-quantity-header-v2',
            className: `${hasBrokerageRASOrAdvisoryFund ? brokerageRightAlignedCell : rightAlignedCell} cds-cost-column-headers-v2`,
            title: 'Shares',
            variant: 'group'
        },
        {
            id: 'cds-cost-per-share-header-v2',
            className: `${hasBrokerageRASOrAdvisoryFund ? brokerageRightAlignedCell : rightAlignedCell} cds-cost-column-headers-v2`,
            title: 'Cost Per Share',
            variant: 'group'
        },
        {
            id: 'cds-cost-basis-amount-header-v2',
            className: `${hasBrokerageRASOrAdvisoryFund ? brokerageRightAlignedCell : rightAlignedCell} cds-cost-column-headers-v2`,
            title: 'Cost Basis Amount',
            variant: 'group'
        },
        {
            id: 'cds-market-value-header-v2',
            className:`${hasBrokerageRASOrAdvisoryFund ? brokerageRightAlignedCell : rightAlignedCell} cds-market-term-and-total-headers-v2`,
            title: 'Market Value',
            variant: 'group'
        }
    ];

    if (hasBrokerageRASOrAdvisoryFund) {
        headers.push(
            {
                id: 'cds-short-term-header-v2',
                className: `${brokerageRightAlignedCell} cds-market-term-and-total-headers-v2`,
                title: 'Short-Term Unrealized Gain/Loss',
                variant: 'group'
            },
            {
                id: 'cds-long-term-header-v2',
                className: `${brokerageRightAlignedCell} cds-market-term-and-total-headers-v2`,
                title: 'Long-Term Unrealized Gain/Loss',
                variant: 'group'
            }
        );
    }

    headers.push({
        id: 'cds-total-urz-gain-loss-header-v2',
        className: `${hasBrokerageRASOrAdvisoryFund ? brokerageRightAlignedCell : rightAlignedCell} cds-market-term-and-total-headers-v2 cds-last-header-v2`,
        title: 'Total Unrealized Gain/Loss',
        variant: 'group'
    });

    return headers;
};

export const realizedTableColumns = [
    'shortTermGainLossAmount',
    'longTermGainLossAmount',
    'totalGainLossAmount',
    'totalGainLossPercent',
    'proceeds',
    'costBasisAmount',
];


export const realizedTableHeaders = [
    {
        id: 'cds-realized-accounts-header-v2',
        className: `${leftAlignedCell} cds-account-header-v2`,
        title: 'Accounts',
        variant: 'group'
    },
    {
        id: 'cds-short-term-header-v2',
        className: rightAlignedCell,
        title: 'Short-Term Realized Gain/Loss',
        variant: 'group'
    },
    {
        id: 'cds-long-term-header-v2',
        className: rightAlignedCell,
        title: 'Long-Term Realized Gain/Loss',
        variant: 'group'
    },
    {
        id: 'cds-total-rz-gain-loss-header-v2',
        className: `${rightAlignedCell} cds-market-term-and-total-headers-v2`,
        title: 'Total Realized Gain/Loss',
        variant: 'group'
    },
    {
        id: 'cds-proceeds-header-v2',
        className: rightAlignedCell,
        title: 'Proceeds',
        variant: 'group'
    },
    {
        id: 'cds-cb-amount-header-v2',
        className: `${rightAlignedCell} cds-last-header-v2`,
        title: 'Cost Basis Amount',
        variant: 'group'
    }
];
